// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Common Client V2 imports
const { keyedReviver } = require('client-v2/common/state/revivers')

class UserStatsRecord extends Immutable.Record({
  followers: Number(),
  'followed_mixes': Number(),
  friends: Number(),
  mixes: Number(),
  posts: Number()
}) {
  // No methods
}

UserStatsRecord.reviver = keyedReviver(UserStatsRecord, {
  // No nested data structures
})

UserStatsRecord.propTypes = {
  followers: PropTypes.number,
  'followed_mixes': PropTypes.number,
  friends: PropTypes.number,
  mixes: PropTypes.number,
  posts: PropTypes.number
}

module.exports = UserStatsRecord
